import * as Yup from 'yup';
import './LoginPage.css';
import FormikFieldInputGroup from '../../components/form/formik/FormikFieldInputGroup';
import { Field, Form, Formik } from 'formik';
import { Button, Spinner } from 'react-bootstrap';
import { loginEndpoint } from '../../api/ApiEndpoints';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { saveLogin } from '../../redux/slices/LoginSlice';
import { useAlert } from 'react-alert';

const validationSchema = Yup.object().shape({
    username: Yup.string().required(),
    password: Yup.string().required(),
});
const LoginPage = () => {
    const { t } = useTranslation('login');
    const alert = useAlert();
    const navigate = useNavigate();

    const dispatch = useDispatch();

    return (
        <Formik
            initialValues={{
                username: '',
                password: '',
            }}
            onSubmit={(login, helper) => {
                loginEndpoint(login)
                    .then(({ data }) => {
                        dispatch(saveLogin(data));
                    })
                    .then(() => {
                        navigate('/');
                    })
                    .catch(() => alert.error(t('alert:loginFailure')))
                    .finally(() => helper.setSubmitting(false));
            }}
            validationSchema={validationSchema}
        >
            {(props) => {
                return (
                    <div className="login_style">
                        <div className="login_text center">
                            <h1>{t('common:appName')}</h1>
                        </div>
                        <div className="login_box">
                            <Form className={"login_form"}>
                                <Field
                                    name="username"
                                    labelText={t('labels.username')}
                                    type="text"
                                    component={FormikFieldInputGroup}
                                />
                                <Field
                                    name="password"
                                    labelText={t('labels.password')}
                                    type="password"
                                    component={FormikFieldInputGroup}
                                />

                                <div className="text-center">
                                    {props.isSubmitting ? (
                                        <Button variant="primary" disabled>
                                            <Spinner
                                                as="span"
                                                animation="grow"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />
                                            {t('common:buttons.processing')}
                                        </Button>
                                    ) : (
                                        <Button type="submit" variant="primary">
                                            {t('common:buttons.login')}
                                        </Button>
                                    )}
                                </div>
                            </Form>
                            <div>
                                <span className={'lost_password'}
                                      onClick={() => navigate('/remember-password')}>
                                    {t('rememberPassword')}
                                </span>
                            </div>
                        </div>
                    </div>
                );
            }}
        </Formik>
    );
};

export default LoginPage;
